import { AppLauncher } from "@capacitor/app-launcher";
import { Capacitor } from "@capacitor/core";

export const buildGoogleDirectionsUrl = (lat, lng) =>
  `https://www.google.com/maps/dir/?api=1&origin=current+location&destination=${lat},${lng}&travelmode=walking`;

export const buildSystemDirectionsUrl = (lat, lng) => {
  if (Capacitor.isNativePlatform()) {
    if (Capacitor.getPlatform() === "ios") {
      return `maps://?daddr=${lat},${lng}&dirflg=w`;
    }

    if (Capacitor.getPlatform() === "android") {
      return `geo:0,0?q=${lat},${lng}`;
    }
  }

  return buildGoogleDirectionsUrl(lat, lng);
};

export const openDirections = async (coordinates) => {
  if (!coordinates) return;

  const [lng, lat] = coordinates;
  const systemUrl = buildSystemDirectionsUrl(lat, lng);
  const fallbackUrl = buildGoogleDirectionsUrl(lat, lng);

  if (Capacitor.isNativePlatform()) {
    try {
      await AppLauncher.openUrl({ url: systemUrl });
      return;
    } catch (error) {
      console.log("Unable to open system maps, falling back to Google Maps", error);
    }
  }

  window.open(fallbackUrl, "_blank");
};
